var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasOneShowingChild(_vm.item.appColumnRespVOList, _vm.item) &&
    (!_vm.onlyOneChild.appColumnRespVOList ||
      _vm.onlyOneChild.noShowingChildren)
    ? _c(
        "div",
        { staticClass: "menu-nav-item" },
        [
          !_vm.isDevMenu(_vm.onlyOneChild.code)
            ? _c(
                "app-link",
                {
                  attrs: {
                    to: _vm.resolvePath(
                      _vm.onlyOneChild.path,
                      _vm.onlyOneChild.query
                    ),
                    item: _vm.onlyOneChild,
                  },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.activeMenuChange.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "el-menu-item",
                    {
                      class: { "submenu-title-noDropdown": !_vm.isNest },
                      attrs: { index: _vm.resolvePath(_vm.onlyOneChild.path) },
                    },
                    [
                      _c("item", {
                        attrs: {
                          icon: _vm.onlyOneChild.icon || _vm.item.icon,
                          title: _vm.onlyOneChild.name,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "div",
                {
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.devMenuClick.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "el-menu-item",
                    {
                      class: { "submenu-title-noDropdown": !_vm.isNest },
                      attrs: { index: _vm.resolvePath(_vm.onlyOneChild.path) },
                    },
                    [
                      _c("item", {
                        attrs: {
                          icon: _vm.onlyOneChild.icon || _vm.item.icon,
                          title: _vm.onlyOneChild.name,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "menu-nav-item" },
        [
          _c(
            "el-submenu",
            {
              ref: "subMenu",
              class: {
                "is-active": _vm.activeIndex === _vm.resolvePath(_vm.item.path),
              },
              attrs: {
                "popper-class": "my-submenu-pop",
                index: _vm.resolvePath(_vm.item.path),
                "popper-append-to-body": false,
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("item", {
                        attrs: { icon: _vm.item.icon, title: _vm.item.name },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            _vm._l(_vm.item.appColumnRespVOList, function (child) {
              return _c(
                "nav-item",
                _vm._b(
                  {
                    key: child.path,
                    staticClass: "nest-menu",
                    attrs: {
                      "is-nest": true,
                      item: child,
                      "base-path": _vm.resolvePath(child.path),
                      "active-index": _vm.activeIndex,
                    },
                  },
                  "nav-item",
                  _vm.$attrs,
                  false
                )
              )
            }),
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }